import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';

import { FullPageNotFound } from '#/components/ui/FullPageNotFound';
import {
  getCategoryBreadcrumbLabel,
  isSupportedCategory,
} from '#/lib/category-navigation';

export const Route = createFileRoute('/$category')({
  beforeLoad: ({ params }) => {
    const { category } = params;
    if (!isSupportedCategory(category)) {
      throw notFound();
    }
    const breadcrumb = getCategoryBreadcrumbLabel(category);
    return { breadcrumb };
  },
  notFoundComponent: () => <FullPageNotFound message="Category not found." />,
  component: () => <Outlet />,
});
